import type { tLayerSettings } from '@/atoms';
import type { LandXMLCategory } from '@/core/landxml';
import type { Map2dKind } from '@gis/landxml';

/**
 * The hex colour a LandXML layer draws a category in: the layer's
 * `landxmlCategoryColors` override, falling back to the 3D defaults. Shared by
 * the 3D view (`LandXML.tsx`) and the 2D map so both always agree (spec D7).
 */
export function landxmlCategoryColor(category: LandXMLCategory, settings: tLayerSettings): string {
  const colors = settings.landxmlCategoryColors;
  switch (category) {
    case 'SURFACE':
      return colors?.surface ?? settings.modelDefaultColor;
    case 'ALIGNMENT':
      return colors?.alignment ?? '#e53935';
    case 'PARCEL':
      return colors?.parcel ?? '#43a047';
    case 'BREAKLINE':
      return colors?.breakline ?? '#787878';
    case 'PIPE':
      return colors?.pipe ?? '#8b6914';
    case 'STRUCTURE':
      return colors?.structure ?? '#607d8b';
  }
}

/** Which LandXML category's colour a 2D sidecar feature kind borrows. */
export const MAP2D_KIND_CATEGORY: Record<Exclude<Map2dKind, 'ifcElement'>, LandXMLCategory> = {
  alignment: 'ALIGNMENT',
  surfaceOutline: 'SURFACE',
  breakline: 'BREAKLINE',
  parcel: 'PARCEL',
  pipe: 'PIPE',
  structure: 'STRUCTURE',
};
